import script from "./CalendarioAgendamentoGrupoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioAgendamentoGrupoPage.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioAgendamentoGrupoPage.vue?vue&type=style&index=0&id=11e99a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e99a96"]])

export default __exports__